<template>
  <div>
    <!-- Date Picker Input Field -->
    <div v-if="type === 'datePicker'">
      <Datepicker
        v-model="date"
        :enableTimePicker="false"
        autoApply
        :placeholder="placeholder"
        :disabled="disabledInputField"
        inputClassName="style-input-field"
        format="dd-MM-yyyy"
      ></Datepicker>
    </div>
    <div style="position: relative" v-else>
      <!-- Input Field -->
      <input
        :type="showPassword ? 'text' : type"
        :placeholder="placeholder"
        :class="[
          errorValidate ? 'style-input-error-message' : '',
          inputFieldClass ? inputFieldClass : 'style-input-field',
          'form-control',
        ]"
        :style="type === 'password' ? 'padding-right: 50px;' : ''"
        :value="value"
        @input="$emit('update:value', $event.target.value)"
        :disabled="disabledInputField"
      />
      <!-- Hide Password Button -->
      <i
        v-if="type === 'password'"
        :class="[
          showPassword ? 'bi-eye-fill' : 'bi-eye-slash-fill',
          'bi scss-click-effect style-password-icon-toggle',
        ]"
        @click="handleToggle"
      ></i>
    </div>
    <div class="text-start text-danger" v-if="errorValidate">
      <span>{{ errorValidate }}</span>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment-timezone";

import { dateTimeFormat } from "@/common/constant/DateTimeFormat";

export default {
  name: "DefaultInputField",
  props: {
    id: String,
    value: String,
    type: String,
    placeholder: String,
    disabledInputField: Boolean,
    errorValidate: String,
    inputFieldClass: {
      type: String,
      default: null,
    },
  },
  components: {
    Datepicker,
  },
  data() {
    return {
      showPassword: false,
      date: this.value,
    };
  },
  methods: {
    handleToggle() {
      this.showPassword = !this.showPassword;
    },
  },
  watch: {
    disabledInputField(value) {
      if (this.type === "datePicker" && value) {
        this.date = this.value;
      }
    },
    date(value) {
      value
        ? this.$emit(
            "update:value",
            moment(value).format(dateTimeFormat.API_DATE_FORMAT)
          )
        : this.$emit("update:value", "");
    },
  },
};
</script>

<style lang="scss">
.style-input-field:focus,
.style-input-field:focus {
  outline: none;
  box-shadow: none;
  border-color: #4a4a4a;
}

input::-ms-reveal,
input::-ms-clear {
  display: none;
}

.style-input-field {
  height: 50px;
  border: 1px solid #adadad;
}
.style-input-field:focus {
  border-color: #4a4a4a;
}
.style-input-error-message {
  border: 1px solid $error-color;
}
.style-input-error-message:focus {
  border-color: $error-color;
}

.style-password-input {
  height: 50px;
  border: 1px solid #adadad;
  font-weight: 100;
  padding-right: 50px;
}

.style-password-icon-toggle {
  color: #acacac !important;
  font-size: 20px;
  position: absolute;
  right: 20px;
  top: 10px;
}

.dp__disabled {
  background: #e9ecef;
}
</style>
